import controller from './monthly-reporting-row-controller';
import template from './monthly-reporting-row.html'

const MonthlyReportingRowComponent = {
    bindings: {
        columns: '<',
        isRollupEnabled: '<',
        onRowSelect: '&',
        popoverTemplate: '<',
        report: '<',
        selectedMonthIndices: '<'
    },
    controller,
    template,
};

export default MonthlyReportingRowComponent;



// WEBPACK FOOTER //
// ./app/common/monthly-reporting/monthly-reporting-row/monthly-reporting-row-component.js